document.addEventListener('alpine:init', () => {
  Alpine.store('cart_count', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    init() {
      // Always update from cart.js first to get accurate count
      this.updateFromCart();

      window.addEventListener('shapes:modalcart:afteradditem', (e) => {
        this._setFromFetchedSection(e.detail.response);
        // Always verify with cart.js after update
        setTimeout(() => this.updateFromCart(), 100);
      });

      window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
        this._setFromFetchedSection(e.detail.response);
        // Always verify with cart.js after update
        setTimeout(() => this.updateFromCart(), 100);
      });

      // Periodically sync with cart.js to ensure accuracy
      setInterval(() => {
        this.updateFromCart();
      }, 5000); // Check every 5 seconds
    },
    _setFromFetchedSection(data) {
      // Prefer item_count from response data (most accurate)
      if (data.item_count !== undefined) {
        this.count = parseInt(data.item_count, 10);
        return;
      }

      // Fallback to section HTML
      const countSectionHTML = data.sections?.['cart-item-count'];
      if (countSectionHTML) {
        this.count = parseInt(
          parseDOMFromString(countSectionHTML).firstElementChild.innerText.trim(),
          10
        );
      } else if (data.items) {
        // Fallback: calculate from items array
        this.count = data.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
      }
    },
    // Method to update count directly from cart.js (most reliable)
    async updateFromCart() {
      try {
        const cartRes = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });
        const cart = await cartRes.json();
        if (cart.item_count !== undefined) {
          const newCount = parseInt(cart.item_count, 10);
          if (this.count !== newCount) {
            this.count = newCount;
          }
        }
      } catch (e) {
        console.warn('Failed to update cart count:', e);
      }
    },
    countWithText() {
      let string = theme.strings.itemCountOther;

      if (this.count === 1) {
        string = theme.strings.itemCountOne;
      }

      return string.replace('{{ count }}', this.count);
    },
  });
});
